'use strict';

var isCurrentPageCartPage = typeof shoppingCartUrl !== 'undefined' && window.location.pathname === shoppingCartUrl;

function onSignUpClick(url) {
    pushDataLayerSignIn();
    window.location = url;
}

function onNewUserClick(url) {
    pushDataLayerCheckoutSignIn();
    window.location = url;
}

var displayErrorLoginMessage = function (message, link) {
    if (link === undefined) {
        link = '#username';
    }

    var $messages = $('#loginMessages');
    $messages.text(message);
    $messages.attr('href', link);

    $('#loginFormError').show();
    $('#loginFormError').children('ul').attr('tabindex', '1');
    $('#loginFormError').children('ul').focus();
};

var disabledAccount = function () {
    displayErrorLoginMessage($('#popover-sign-in-box-button').attr('data-loginDisabled'));
    $("label[for='username']").addClass('error');
    $('#username').addClass('error');
    $("label[for='password']").addClass('error');
    $('#password').addClass('error');
};

var lockedAccount = function () {
    displayErrorLoginMessage($('#popover-sign-in-box-button').attr('data-loginAccountLocked'));
    $("label[for='username']").addClass('error');
    $('#username').addClass('error');
    $("label[for='password']").addClass('error');
    $('#password').addClass('error');
};

var sendAjaxRequestForValidation = function (data) {
    var deferred = jQuery.Deferred();

    $('#modal-sign-in-box-conflict-container').addClass('in-progress');

    $.ajax({
        url: loginValidateUrl,
        method: 'POST',
        data: data,
        xhrFields: {
            withCredentials: true
        },
        success: function () {
            deferred.resolve();
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR, false);
        }
    });
    return deferred;
};